export const tariffStyles = (theme) => ({})
